/**
 * Frontend feature flags.
 *
 * Single source of truth for features that we want to dark-launch, hide
 * temporarily, or kill-switch without touching multiple call sites.
 */

/**
 * Community / Explore gallery. When `false`:
 *   - `/explore` and `/dashboard` routes redirect to Landing
 *   - The CommunityGalleryPreview section on the Landing page is hidden
 *   - The footer link to Explore is hidden
 *
 * Flip to `true` to restore the full Community feature.
 */
export const COMMUNITY_ENABLED = false;

/**
 * Controlled wind-down kill-switches (pre-shutdown). UX only — the server
 * (Supabase signup toggle, PAYMENTS_CLOSED / PAID_USERS_ONLY envs) is the
 * authoritative enforcement.
 *
 * `SIGNUPS_ENABLED = false`: the signup form is replaced by a "registration
 *   closed" message; sign-in stays available for existing users.
 * `PURCHASES_ENABLED = false`: purchase CTAs (plans + token packs) are
 *   disabled with a "purchases closed" notice; subscription management stays.
 * `GENERATION_PAID_ONLY = true`: the generation/task form is disabled for
 *   non-subscribers (UX mirror of the server PAID_USERS_ONLY env gate).
 * `WIND_DOWN_BANNER_ENABLED = true`: shows the landing-page announcement bar
 *   pointing users to our new product.
 *
 * To activate the wind-down, flip all four together (plus the server
 * PAYMENTS_CLOSED / PAID_USERS_ONLY envs and the Supabase signup toggle).
 */
export const SIGNUPS_ENABLED = false;
export const PURCHASES_ENABLED = false;
export const GENERATION_PAID_ONLY = true;
export const WIND_DOWN_BANNER_ENABLED = true;
